import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  Type,
  ViewChild
} from '@angular/core';
import {NgComponentOutlet} from '@angular/common';
import {Subscription} from 'rxjs';
import {WidgetComponent, WidgetDto} from '../../../../../Models/Widgets/widget.interface';
import {WidgetsTypesEnum} from '../../../../../Shared/Enum/widgets-types.enum';
import {WIDGET_COMPONENTS} from '../../../../../Shared/Const/widgets.const';

@Component({
  selector: 'app-widget-switch',
  templateUrl: './widget-switch.component.html',
  styleUrls: ['./widget-switch.component.scss'],
  standalone: false
})
export class WidgetSwitchComponent implements AfterViewInit, OnChanges, OnDestroy {

  @ViewChild(NgComponentOutlet) private outlet?: NgComponentOutlet<WidgetComponent>;

  @Input() widget!: WidgetDto;
  @Input() isStoreView: boolean = true;

  @Output() clickWidget: EventEmitter<void> = new EventEmitter<void>();

  component: Type<WidgetComponent> | null = null;
  inputs: Record<string, unknown> = {};

  private clickSub?: Subscription;

  ngOnChanges(changes: SimpleChanges) {
    this.component = WIDGET_COMPONENTS[this.widget?.type as WidgetsTypesEnum] ?? null;
    this.inputs = {widget: this.widget, isStoreView: this.isStoreView};

    if (changes['widget'] && !changes['widget'].firstChange) {
      this.subscribeClick();
    }
  }


  ngAfterViewInit() {
    this.subscribeClick();
  }


  ngOnDestroy() {
    this.clickSub?.unsubscribe();
  }


  /**
   * Actualizar los datos del widget renderizado
   *
   */
  refreshWidgetsData(loadedData: boolean = true) {
    const instance = this.outlet?.componentInstance;

    if (!instance) {
      return;
    }

    instance.loadedData = loadedData;
    instance.getListData();
  }


  /**
   * Suscribirse al `clickWidget` del componente creado por el outlet y reemitirlo
   *
   */
  private subscribeClick() {
    this.clickSub?.unsubscribe();

    const instance = this.outlet?.componentInstance;

    if (!instance) {
      return;
    }

    this.clickSub = instance.clickWidget.subscribe(() => this.clickWidget.emit());
  }

}
